/**
 * Générateur — Automatisme : multiplier des fractions.
 * Attendu ID : 1215 | Niveau : 3ème | Domaine : Nombres rationnels
 * Rubrique : AUTOMATISME (programme 2025, cycle 4 page 11, ligne 728).
 *
 * Les clés produit_* de gen_1213 (un fichier « fractions », quatre jeux de clés,
 * modèle 1246/1247/1248, base du prof du 13/09) : la mécanique, les
 * distracteurs et les sacrifiés sont ceux de gen_1213 ; les payloads
 * portent déjà l'attendu 1215.
 */
import { genererParmi, CATEGORIES_PRODUIT } from './gen_1213';

export const CATEGORIES = CATEGORIES_PRODUIT;
const CLES = CATEGORIES_PRODUIT.flatMap((c) => c.formatsList.map(({ key }) => key));
export const generate = (typeExercice) => genererParmi(CLES, typeExercice);
